import { format, formatInTimeZone } from 'date-fns-tz';
import { isEmpty } from 'lodash';
import moment from 'moment';
import Cookies from 'universal-cookie';

import getViewType from 'Domain/host/helper/getViewType';

const getHostScheduleResponse = (response, previousResponse, page) => {
  const cookies = new Cookies();

  const totalData = response?.totalData ?? 0;
  const totalPage = response?.totalPage ?? 0;
  const currentPage = response?.currentPage;
  const isDataExist = response?.isDataExist;

  let dailySchedules = response?.schedules?.map((dailySchedule) => {
    return {
      date: moment(dailySchedule.date).format('dddd - DD MMMM YYYY'),
      schedules: dailySchedule.schedules?.map((schedule) => {
        const timezone = cookies.get('organization').timezone;
        const startDate = new Date(schedule.startedAt);
        const endDate = new Date(schedule.endedAt);

        return {
          id: schedule.id,
          title: schedule.title,
          achievementStatus: schedule?.achievementStatus && schedule?.achievementStatus !== 'Hide Achievement' ? schedule?.achievementStatus : '',
          datetime: `${format(startDate, 'dd MMM yyyy')} | ${formatInTimeZone(startDate, timezone, 'HH:mm')}-${formatInTimeZone(endDate, timezone, 'HH:mm')}`,
          account:
            schedule.accountLivestreams?.map((account) => {
              return {
                name: account?.name,
                ecommerce: account?.ecommerce,
              };
            }) || [],
          platform: schedule.accountAchievement?.map((account) => account?.ecommerce?.name).join(' | '),
          room: `${schedule?.studio?.room} - ${schedule?.studio?.name}`,
          host: schedule.hosts.map((host) => host?.name).join(' | '),
          operator: schedule.operators.map((operator) => operator?.name).join(' | '),
          isCanRequestReschedule: schedule?.isCanRequestReschedule,
          reschedule: schedule?.reschedule || null,
          rawData: schedule,
        };
      }),
    };
  });

  if (!isEmpty(previousResponse) && page !== 1) dailySchedules = [...previousResponse, ...dailySchedules];

  let isExpandFirstCard = false;

  dailySchedules = dailySchedules?.map((daily) => {
    const viewType = getViewType();

    //add filtering data base on type

    let schedules = daily?.schedules?.filter(({ achievementStatus }) => {
      switch (viewType) {
        case 'upcoming':
          return isEmpty(achievementStatus);

        case 'past':
          return !isEmpty(achievementStatus);

        case 'scheduled':
        default:
          return true;
      }
    });

    //add expanded first icon

    schedules = schedules?.map((schedule, index) => {
      let isExpand = false;

      if (!isExpandFirstCard) {
        isExpand = index === 0;
        isExpandFirstCard = true;
      }

      return { ...schedule, isExpand };
    });

    return { ...daily, schedules };
  });

  return { dailySchedules, totalData, totalPage, isDataExist, currentPage };
};

export default getHostScheduleResponse;
